import React, { useEffect, useState } from 'react';
import PageTitle from '../../Components/PageTitle';
import  code from '../../assets/images/code.png';
import { Link } from 'react-router-dom';
import { routes } from '../../routes';
import { Accordion, Button, Card } from 'react-bootstrap';
import ContentController from '../../apis/controller/content.controller';



function Faq() {
    const [faqs, setFaqs] = useState();
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        getFaq();
        window.scrollTo(0, 0);
    }, []);

    const getFaq = async () => {
        setLoader(true);
        let res = await new ContentController().faq();
        if (res && res.status) {
            setFaqs(res.listing);
        }
        setLoader(false);
    };
	return (
		<>
        <PageTitle title="FAQs" />
        <section className="career_section">
            {faqs ?<div className="container">
                <div className="row">
                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                        <div className="career_detail_area">
                            <Accordion defaultActiveKey="0">
                            {faqs.map((item, index) => (
                                <Accordion.Item eventKey={index}>
                                    <Accordion.Header>
                                        {item.title}
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className="accordion-body">
                                        <p>
                                           {item.description}
                                        </p>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                                {/* <Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        Lorem ipsum sit dor.
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className="accordion-body">
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam lobortis
                                            dolor mauris. Nullam interdum, ectus, vitae malesuada felis ex
                                            tempus diam. Etiam tristique euismod ante, vel ornare urna. Suspendisse
                                            augue purus, hendrerit vel lacus at, aliquam eleifend lacus.
                                            Nam quis nulla sollicitudin enim scelerisque molestie. Vitae malesuada felis
                                            ex tempus diam. Etiam tristique euismod Suspendisse potenti.
                                            Lorem ipsum dolor sit amet. Suspendisse augue purus, hendrerit vel lacus at,
                                            aliquam eleifend lacus. Nam quis nulla sollicitudin enim scelerisque
                                            molestie.
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam lobortis
                                            dolor mauris. Nullam interdum, ectus, vitae malesuada felis ex tempus diam.
                                        </p>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>
                                        Lorem ipsum sit dor.
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className="accordion-body">
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam lobortis
                                            dolor mauris. Nullam interdum, ectus, vitae malesuada felis ex
                                            tempus diam. Etiam tristique euismod ante, vel ornare urna. Suspendisse
                                            augue purus, hendrerit vel lacus at, aliquam eleifend lacus.
                                            Nam quis nulla sollicitudin enim scelerisque molestie. Vitae malesuada felis
                                            ex tempus diam. Etiam tristique euismod Suspendisse potenti.
                                            Lorem ipsum dolor sit amet. Suspendisse augue purus, hendrerit vel lacus at,
                                            aliquam eleifend lacus. Nam quis nulla sollicitudin enim scelerisque
                                            molestie.
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam lobortis
                                            dolor mauris. Nullam interdum, ectus, vitae malesuada felis ex tempus diam.
                                        </p>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>
                                        Lorem ipsum sit dor.
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className="accordion-body">
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam lobortis
                                            dolor mauris. Nullam interdum, ectus, vitae malesuada felis ex
                                            tempus diam. Etiam tristique euismod ante, vel ornare urna. Suspendisse
                                            augue purus, hendrerit vel lacus at, aliquam eleifend lacus.
                                            Nam quis nulla sollicitudin enim scelerisque molestie. Vitae malesuada felis
                                            ex tempus diam. Etiam tristique euismod Suspendisse potenti.
                                            Lorem ipsum dolor sit amet. Suspendisse augue purus, hendrerit vel lacus at,
                                            aliquam eleifend lacus. Nam quis nulla sollicitudin enim scelerisque
                                            molestie.
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam lobortis
                                            dolor mauris. Nullam interdum, ectus, vitae malesuada felis ex tempus diam.
                                        </p>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>
                                        Lorem ipsum sit dor.
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className="accordion-body">
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam lobortis
                                            dolor mauris. Nullam interdum, ectus, vitae malesuada felis ex
                                            tempus diam. Etiam tristique euismod ante, vel ornare urna. Suspendisse
                                            augue purus, hendrerit vel lacus at, aliquam eleifend lacus.
                                            Nam quis nulla sollicitudin enim scelerisque molestie. Vitae malesuada felis
                                            ex tempus diam. Etiam tristique euismod Suspendisse potenti.
                                            Lorem ipsum dolor sit amet. Suspendisse augue purus, hendrerit vel lacus at,
                                            aliquam eleifend lacus. Nam quis nulla sollicitudin enim scelerisque
                                            molestie.
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam lobortis
                                            dolor mauris. Nullam interdum, ectus, vitae malesuada felis ex tempus diam.
                                        </p>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="5">
                                    <Accordion.Header>
                                        Lorem ipsum sit dor.
                                    </Accordion.Header>
                                    <Accordion.Body>
                                    <div className="accordion-body">
                                        <p>
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam lobortis
                                            dolor mauris. Nullam interdum, ectus, vitae malesuada felis ex
                                            tempus diam. Etiam tristique euismod ante, vel ornare urna. Suspendisse
                                            augue purus, hendrerit vel lacus at, aliquam eleifend lacus.
                                            Nam quis nulla sollicitudin enim scelerisque molestie. Vitae malesuada felis
                                            ex tempus diam. Etiam tristique euismod Suspendisse potenti.
                                            Lorem ipsum dolor sit amet. Suspendisse augue purus, hendrerit vel lacus at,
                                            aliquam eleifend lacus. Nam quis nulla sollicitudin enim scelerisque
                                            molestie.
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam lobortis
                                            dolor mauris. Nullam interdum, ectus, vitae malesuada felis ex tempus diam.
                                        </p>
                                    </div>
                                    </Accordion.Body>
                                </Accordion.Item> */}
                            </Accordion>
                        </div>
                    </div>
                </div>
            </div>: null}
        </section>
        </>
    );
}

export default Faq;